import React from 'react';
import styled from 'styled-components';
import { HelmetPageMeta } from '@ts/commons/HelmetPageMeta';
import { buildRootUrl } from '@ts/utils/urls';
import Authentication from '@ts/components/Authentication';

export const Error = styled.h3`
    padding: 18px;
    margin: 0;
`;

const rootUrl = buildRootUrl('/auth/');
const pageMeta = { title: 'TripShock! - Authorization' };

function AuthPage() {
    return (
        <React.Fragment>
            <HelmetPageMeta meta={pageMeta} canonicalUrl={rootUrl} />
            <Authentication />
        </React.Fragment>
    );
}

export default AuthPage;
